import { useAppKitAccount } from '@reown/appkit/react';
import { useEffect } from 'react';

const WALLET_NETWORK_STORAGE_KEY = '@appkit/active_caip_network_id';

// todo: remove this after bug is fixed on the Reown side
/**
 * For more details, see: https://ankrnetwork.atlassian.net/browse/MRPC-6936
 */
export const WrongNetworkWorkaroundListener = () => {
  const { status } = useAppKitAccount();

  useEffect(() => {
    if (status === 'disconnected') {
      localStorage.removeItem(WALLET_NETWORK_STORAGE_KEY);
    }
  }, [status]);

  return null;
};
